import { GridCellProps } from "@progress/kendo-react-grid";

export const StatutCell = (props: GridCellProps) => {
  return (
    <td
      style={{
        color:
          props.dataItem[props.field!] === "Manquant" ||
          props.dataItem.field_highlight
            .toUpperCase()
            .split(",")
            .includes(props.field!.toUpperCase())
            ? "red"
            : "inherit",
      }}
      colSpan={1}
      className="k-table-td"
      role="gridcell"
      aria-colindex={2}
      aria-selected="false"
      data-grid-col-index="1"
      onContextMenu={(ev) => props.onContextMenu!(ev, props.dataItem)}
    >
      {props.dataItem[props.field!]}
    </td>
  );
};